import React, { useCallback, useEffect, useState } from 'react';
interface Ripple {
  id: number;
  x: number;
  y: number;
}
export function CustomCursor() {
  const [position, setPosition] = useState({
    x: -100,
    y: -100
  });
  const [ripples, setRipples] = useState<Ripple[]>([]);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      setPosition({
        x: e.clientX,
        y: e.clientY
      });
      if (!visible) setVisible(true);
    };
    const handleMouseLeave = () => setVisible(false);
    const handleMouseEnter = () => setVisible(true);
    window.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeave);
    document.addEventListener('mouseenter', handleMouseEnter);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseleave', handleMouseLeave);
      document.removeEventListener('mouseenter', handleMouseEnter);
    };
  }, [visible]);
  const handleClick = useCallback((e: MouseEvent) => {
    const id = Date.now();
    setRipples(prev => [...prev, {
      id,
      x: e.clientX,
      y: e.clientY
    }]);
    setTimeout(() => {
      setRipples(prev => prev.filter(r => r.id !== id));
    }, 600);
  }, []);
  useEffect(() => {
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [handleClick]);
  // Don't show custom cursor on touch devices
  const [isTouch, setIsTouch] = useState(false);
  useEffect(() => {
    setIsTouch('ontouchstart' in window);
  }, []);
  if (isTouch) return null;
  return <>
      <style data-id="element-59">{`
        *, *::before, *::after {
          cursor: none !important;
        }
        @keyframes cursor-ripple {
          0% {
            transform: translate(-50%, -50%) scale(0);
            opacity: 0.6;
          }
          100% {
            transform: translate(-50%, -50%) scale(1);
            opacity: 0;
          }
        }
      `}</style>

      {/* Red dot cursor */}
      <div style={{
      position: 'fixed',
      left: position.x,
      top: position.y,
      width: 10,
      height: 10,
      borderRadius: '50%',
      backgroundColor: '#C4342D',
      transform: 'translate(-50%, -50%)',
      pointerEvents: 'none',
      zIndex: 99999,
      opacity: visible ? 1 : 0,
      transition: 'opacity 0.15s ease'
    }} data-id="element-60" />

      {/* Ripples */}
      {ripples.map(ripple => <div key={ripple.id} style={{
      position: 'fixed',
      left: ripple.x,
      top: ripple.y,
      width: 40,
      height: 40,
      borderRadius: '50%',
      border: '2px solid #C4342D',
      pointerEvents: 'none',
      zIndex: 99998,
      animation: 'cursor-ripple 0.6s ease-out forwards'
    }} data-id="element-61" />)}
    </>;
}